"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _stores = require("@seedlang/stores");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var DictionarySentencesWrapper = function DictionarySentencesWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3;
  var DictionarySentences = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function DictionarySentences(props) {
      var _this;
      _classCallCheck(this, DictionarySentences);
      _this = _callSuper(this, DictionarySentences, [props]);
      _this.store = new _stores.WordSentenceStore.constructor();
      _initializerDefineProperty(_this, "loading", _descriptor, _this);
      _initializerDefineProperty(_this, "error", _descriptor2, _this);
      _initializerDefineProperty(_this, "page", _descriptor3, _this);
      _this.request = void 0;
      _this.failedPage = void 0;
      _this.pages = new Map();
      _this.restorePreview = function () {
        var preview = _this.props.initialSentencePage;
        if (!_this.props.infinite || !preview || preview.wordId !== _this.props.wordId || preview.meaningId !== _this.props.meaningId) return;
        _this.store.setIndexData(preview.response);
        _this.loading = _this.store.indexData.length < _this.store.totalCount;
      };
      _this.reportLoadedSentences = function () {
        var _this$props$onSentenc, _this$props;
        (_this$props$onSentenc = (_this$props = _this.props).onSentencesLoaded) === null || _this$props$onSentenc === void 0 || _this$props$onSentenc.call(_this$props, {
          wordId: _this.props.wordId,
          meaningId: _this.props.meaningId,
          sentences: _toConsumableArray(_this.store.indexData)
        });
      };
      _this.startLoading = function () {
        var _this$props$onTotalCo, _this$props2;
        if (_this.store.totalCount != null) _this.reportLoadedSentences();
        if (_this.store.totalCount != null) (_this$props$onTotalCo = (_this$props2 = _this.props).onTotalCount) === null || _this$props$onTotalCo === void 0 || _this$props$onTotalCo.call(_this$props2, _this.store.totalCount);
        if (_this.store.totalCount != null && _this.store.indexData.length >= _this.store.totalCount) {
          _this.loading = false;
          return;
        }
        _this.loadPage(1);
      };
      _this.loadMore = function () {
        if (_this.loading || _this.error || _this.store.indexDataFullyLoaded || _this.store.indexData.length >= _this.store.totalCount) return;
        _this.loadPage(_this.page + 1);
      };
      _this.retry = function () {
        return _this.loadPage(_this.failedPage || 1);
      };
      _this.loadPage = function (page) {
        if (!_this.props.wordId) return;
        var request = {};
        _this.request = request;
        _this.error = false;
        _this.store.page = page;
        if (!_this.props.infinite && _this.pages.has(page)) {
          _this.store.setIndexData(_this.pages.get(page));
          _this.page = page;
          _this.reportLoadedSentences();
          _this.loading = false;
          return;
        }
        _this.loading = true;
        var onError = function onError() {
          if (_this.request !== request) return;
          _this.loading = false;
          _this.error = true;
          _this.failedPage = page;
        };
        _this.store.getIndex({
          ids: {
            wordId: _this.props.wordId
          },
          limit: _this.props.infinite ? 10 : 3,
          queryStrings: _objectSpread(_objectSpread({
            dictionary_sentences: true
          }, _this.props.meaningId ? {
            meaning_sentences_id: _this.props.meaningId
          } : _this.props.allSentences ? {} : {
            association_meaning_id: 'unassigned'
          }), {}, {
            include_count: true
          }),
          failureCallback: onError,
          onRequestError: onError
        }, function (response) {
          var _this$props$onTotalCo2, _this$props3;
          if (_this.request !== request) return;
          if (!_this.props.infinite) _this.pages.set(page, response);
          _this.store.setIndexData(response, {
            addToIndexData: _this.props.infinite && page > 1
          });
          _this.page = page;
          _this.reportLoadedSentences();
          (_this$props$onTotalCo2 = (_this$props3 = _this.props).onTotalCount) === null || _this$props$onTotalCo2 === void 0 || _this$props$onTotalCo2.call(_this$props3, _this.store.totalCount);
          if (!_this.props.infinite && page === 1) {
            var _this$props$onSentenc2, _this$props4;
            (_this$props$onSentenc2 = (_this$props4 = _this.props).onSentencePage) === null || _this$props$onSentenc2 === void 0 || _this$props$onSentenc2.call(_this$props4, {
              wordId: _this.props.wordId,
              meaningId: _this.props.meaningId,
              response: response
            });
          }
          _this.loading = false;
        });
      };
      _this.restorePreview();
      return _this;
    }
    _inherits(DictionarySentences, _React$Component);
    return _createClass(DictionarySentences, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.startLoading();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.wordId !== this.props.wordId || prevProps.meaningId !== this.props.meaningId || prevProps.allSentences !== this.props.allSentences || prevProps.infinite !== this.props.infinite) {
          this.request = null;
          this.failedPage = null;
          this.error = false;
          this.loading = true;
          this.page = 1;
          this.pages.clear();
          this.store.clearIndexData();
          this.restorePreview();
          this.startLoading();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.request = null;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          store: this.store,
          loading: this.loading,
          error: this.error,
          page: this.page,
          loadPage: this.loadPage,
          loadMore: this.loadMore,
          retry: this.retry
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "loading", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "error", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "page", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 1;
    }
  }), _class2)) || _class;
  return DictionarySentences;
};
var _default = exports["default"] = DictionarySentencesWrapper;